import { useEffect, useState } from 'react';

/**
 * O valor, só depois que ele parou de mudar por `ms` milissegundos.
 *
 * É o que impede a verificação de conflito de `#m-reserva` de disparar
 * uma consulta por tecla: quem troca o início de 19:00 para 20:30
 * passando por quatro opções do seletor quer uma resposta, não quatro.
 *
 * A comparação é pelo conteúdo (JSON), não pela referência: o
 * formulário monta um objeto novo a cada render.
 */
export function useAtrasado<T>(valor: T, ms: number): T {
  const [atrasado, setAtrasado] = useState(valor);
  const chave = JSON.stringify(valor);

  useEffect(() => {
    const temporizador = setTimeout(() => setAtrasado(JSON.parse(chave) as T), ms);
    return () => clearTimeout(temporizador);
  }, [chave, ms]);

  return atrasado;
}
